<template>
<div class="odr-boxmenu">
    <button v-for="item in values"
            :key="item.id"
            type="submit"
            class="odr-boxmenu__item"
            :data-qa="dataQa ? dataQa + '.' + item.id : null"
            @click="$emit('input', item.id)">
        <div class="odr-boxmenu__icon">
            <icon size="l" :alt="item.alt">{{ item.icon }}</icon>
        </div>
        <div class="odr-boxmenu__text">
            <tpl :content="item.description || item.title || item.match"/>
        </div>
    </button>
</div>
</template>

<script>
import '@/scss/blocks/boxmenu.scss';

export default {
    props: ['dataQa', 'value', 'values', 'title'],
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
        icon: require('@clearwave/odoro-markup/lib/vue/icon.vue').default,
    },
};
</script>
